import {stage} from "../../../config/stage.ts";

export const moduleConfig = {
    pricingPageTitle: 'Flexi Bot Service Plans',
    pricingPageSmallScript: 'Please note that these prices are subject to change. Actual prices may vary'
}

// flexinet-platform-api
const platformAPI = {
    prod: {
        endpoint: 'https://jerup2o5nzej3hnn2sdv3ejtca.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
        applicationId: 'f2bfbc00-3e46-4327-9998-7ec47fd6e36c',
    },
    test: {
        endpoint: 'https://thz4u5ksajh6blvulnhiiddudi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
        applicationId: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
    },
    dev: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
        applicationId: '688679a2-2983-4299-b7e6-ec87fb538c24',
    },
    ide: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
        applicationId: '688679a2-2983-4299-b7e6-ec87fb538c24',
    },
};

export const platformApiConfig = platformAPI[stage];
